/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-22-09 00:0:00
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import { SubmissionError } from 'redux-form';
import { fakedData } from './index';

class LocationHelper {
  /**
   * Init values from first loading
   *
   * @param  {object} filterOption  filter option value
   * @param  {object} initialValue default values
   *
   * @return {object}               init values
   */
  static initialValues = (filterOption, initialValue) => {
    const {
      inventoryStatus = 'product_quantity', // By default, product quantity for old stores
      displayType,
      manualValues,
      valueType,
      selectType,
      excludedValues,
      nonFulfillmentValues = [],
      inventoryBaseSelectedLocations = false
    } = filterOption;

    let locationManualValues = [];
    let locationExcludedValues = [];
    let locationNonFulfillmentValues = []; // Hidden field

    if (valueType === 'available_sale_online') {
      locationExcludedValues = _.map(excludedValues, item => ({
        value: item,
        label: item
      }));
      locationNonFulfillmentValues = _.map(nonFulfillmentValues, item => ({
        value: item,
        label: item
      }));
    } else if (valueType === 'specific') {
      locationManualValues = _.map(manualValues, item => ({
        value: item,
        label: item
      }));
    } else {
      locationExcludedValues = _.map(excludedValues, item => ({
        value: item,
        label: item
      }));
    }

    // For old store: Doesn't exist field inventoryStatus (product_quantity by default) and inventoryBaseSelectedLocations = true
    // Force render toggle switch Inventory base selected locations
    const locationForceDisplayInventoryBaseSelectedLocations =
      inventoryStatus === 'product_quantity' && inventoryBaseSelectedLocations;

    const result = {
      ...initialValue,
      locationInventoryStatus: inventoryStatus,
      locationDisplayType: displayType,
      locationOptionSelect: selectType,
      locationOptionValues: valueType,
      locationManualValues,
      locationExcludedValues,
      locationNonFulfillmentValues,
      locationInventoryBaseSelectedLocations: inventoryBaseSelectedLocations,
      locationForceDisplayInventoryBaseSelectedLocations
    };

    return result;
  };

  /**
   * Build filter option data based on input values
   *
   * @param  {object} filterOption    input values
   * @param  {object} defaultValues   default values
   *
   * @return {object}                 filter option values
   */
  static buildFilterOptionValues = (filterOption, defaultValues) => {
    const {
      locationInventoryStatus,
      locationDisplayType,
      locationOptionSelect,
      locationOptionValues,
      locationManualValues,
      locationExcludedValues,
      locationNonFulfillmentValues = [],
      locationInventoryBaseSelectedLocations = false
    } = filterOption;

    let manualValues = null;
    let excludedValues = null;
    let nonFulfillmentValues = null;
    if (locationOptionValues === 'available_sale_online') {
      excludedValues = _.map(locationExcludedValues, location => location.value);
      nonFulfillmentValues = _.map(locationNonFulfillmentValues, location => location.value);
    } else if (locationOptionValues === 'specific') {
      manualValues = _.map(locationManualValues, location => location.value);
    } else {
      excludedValues = _.map(locationExcludedValues, location => location.value);
    }

    // Variant quantity => Inventory status = true
    // Product quantity => Inventory status = false

    const result = {
      ...defaultValues,
      inventoryStatus: locationInventoryStatus,
      displayType: locationDisplayType,
      selectType: locationOptionSelect,
      valueType: locationOptionValues,
      manualValues,
      removeTextFilterValues: '',
      replaceTextFilterValues: null,
      excludedValues,
      nonFulfillmentValues,
      inventoryBaseSelectedLocations: locationInventoryBaseSelectedLocations
    };

    return result;
  };

  /**
   * Validate for location
   *
   * @param  {object} filterOption
   * @param  {I18n} i18n
   *
   * @return {boolean/error} void if well validated, throw error if have
   */
  static validateFilterOption = (filterOption, i18n) => {
    // Check manual value
    if (filterOption.locationOptionValues === 'specific') {
      if (_.isEmpty(filterOption.locationManualValues)) {
        throw new SubmissionError({
          locationManualValues: i18n.translate(
            'AdminHTML.FilterTree.Helper.locationHelper_ValidateFilterOption_SubmissionError'
          )
        });
      }
    }
  };

  /**
   * Fake product data for location
   *
   * @param  {object} filterOption
   * @return {array}              list of product count
   */
  static fakeProductValues = filterOption => {
    const values = fakedData(filterOption, 'locations');
    return values;
  };
}

export default LocationHelper;
